import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  roleList: { data: [], loading: false },
  mineAcls: { data: [], loading: false },
  orgAcls: { data: [], loading: false },
  roleAcls: { data: [], loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
